import { FormInstance } from "antd/es/form";
import React from "react";
import { IValidationData } from "../../models/dto/validation-data";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

export interface ITeslimatYukle_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface ITeslimatYukle_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  CheckSmsCodeIsUsed: any[];
  CheckSmsCodeIsUsed_dummy: any[];
  GetTeslimatBilgiBySMSCode: any[];
  GetTeslimatBilgiBySMSCode_dummy: any[];
  YuklemePlan_Get_TeslimEvrakListe: any[];
  YuklemePlan_Get_TeslimEvrakListe_dummy: any[];
  Notify: boolean;
  Notify_dummy: boolean;
  PhotosFromGallery: any[];
  PhotosFromGallery_dummy: any[];
  YuklemePlan_Save_TeslimEvrak: any[];
  YuklemePlan_Save_TeslimEvrak_dummy: any[];
  YuklemePlan_TeslimatKaydet: number;
  YuklemePlan_TeslimatKaydet_dummy: number;
  isComp622971Visible: "visible" | "hidden";
  isComp449349Visible: "visible" | "hidden";
  isComp280251Visible: "visible" | "hidden";
  isComp488681Enabled: "enabled" | "disabled";
  isComp992715Enabled: "enabled" | "disabled";
}

export class TeslimatYukle_ScreenBase extends React.PureComponent<
  ITeslimatYukle_ScreenProps,
  any
> {
  teslimatyukle_185972_value_kuikaCarouselRef: React.RefObject<any>;
  ml = [
    {
      Id: "585b6303-ac4a-473f-8893-c915ede3bf84",
      Name: "en_US",
      ShortName: "English",
      IsDefault: true,
      LanguagePhrases: [],
    },
    {
      Id: "f00181a6-3ddc-41f6-8183-9233ef7cadb8",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 250709, PropertyName: "value", Value: "Müşteri" },
        { Id: 488681, PropertyName: "placeholder", Value: "Type here..." },
        { Id: 943981, PropertyName: "value", Value: "Teslim Yeri" },
        { Id: 992715, PropertyName: "placeholder", Value: "Type here..." },
        { Id: 947103, PropertyName: "label", Value: "Teslim Evrakı Yükle" },
        {
          Id: 185972,
          PropertyName: "nodatafoundmessage",
          Value: "No data found.",
        },
        { Id: 918250, PropertyName: "value", Value: "İADE VAR MI ?" },
        { Id: 635388, PropertyName: "value", Value: "HASARLI İADE VAR MI ?" },
        { Id: 622971, PropertyName: "placeholder", Value: "0" },
        { Id: 317963, PropertyName: "value", Value: "EKSİK/FAZLA VAR MI ?" },
        { Id: 449349, PropertyName: "placeholder", Value: "0" },
        { Id: 204713, PropertyName: "value", Value: "AÇIKLAMA" },
        { Id: 242782, PropertyName: "placeholder", Value: "Type here..." },
        { Id: 280251, PropertyName: "label", Value: "Teslimatı Bitir" },
      ],
    },
  ];
  defaultML = "en_US";

  screenHash = "";

  constructor(props) {
    super(props);
    this.teslimatyukle_488681_value_kuikaTextInputRef = React.createRef();
    this.teslimatyukle_992715_value_kuikaTextInputRef = React.createRef();
    this.teslimatyukle_185972_value_kuikaCarouselRef = React.createRef();
    this.teslimatyukle_242782_value_kuikaTextInputRef = React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      CheckSmsCodeIsUsed: [],
      GetTeslimatBilgiBySMSCode: [],
      YuklemePlan_Get_TeslimEvrakListe: [],
      Notify: false,
      PhotosFromGallery: [],
      YuklemePlan_Save_TeslimEvrak: [],
      YuklemePlan_TeslimatKaydet: 0,
      isComp622971Visible: "hidden",
      isComp449349Visible: "hidden",
      isComp280251Visible: "hidden",
      isComp488681Enabled: "disabled",
      isComp992715Enabled: "disabled",
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight("teslimatyukle", "");
      return;
    }

    this.fillFormInitValues();
    if (true) {
      await this.TeslimatYuklePageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight("teslimatyukle", "");

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("teslimatyukle", "");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.TeslimatYuklePageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({
      teslimatyukle_488681_value:
        this.state.GetTeslimatBilgiBySMSCode?.at?.(0)?.musteriAdi ?? undefined,
      teslimatyukle_992715_value:
        this.state.GetTeslimatBilgiBySMSCode?.at?.(0)?.noktaAdi ?? undefined,
      teslimatyukle_752493_value: false,
      teslimatyukle_966026_value: false,
      teslimatyukle_622971_value: 0,
      teslimatyukle_156919_value: false,
      teslimatyukle_449349_value: 0,
    });
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  TeslimatYuklePageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      SmsCode_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.SMSCode ?? this.props.screenInputs.smscode,
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "TeslimatYukle/TeslimatYuklePageInit",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.CheckSmsCodeIsUsed = result?.data.checkSmsCodeIsUsed;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.TeslimatYuklePageInit1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  TeslimatYuklePageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      SMSCode_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.SMSCode ?? this.props.screenInputs.smscode,
        "string"
      ),
    };

    if (
      ReactSystemFunctions.isGreaterThan(
        ReactSystemFunctions.value(
          this,
          stateVars.CheckSmsCodeIsUsed !== undefined
            ? stateVars.CheckSmsCodeIsUsed?.length > 0
              ? stateVars.CheckSmsCodeIsUsed[0].kontrol
              : null
            : this.state.CheckSmsCodeIsUsed?.length > 0
            ? this.state.CheckSmsCodeIsUsed[0].kontrol
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("0", "string")
      )
    ) {
      if (true) {
        KuikaAppManager.showSpinner(this);
      }
      let result = await KuikaAppManager.ApiRequest(
        this,
        "TeslimatYukle/TeslimatYuklePageInit1_",
        localVar
      );
      if (!KMainFunctions.IsResStatus2XX(result)) return true;

      stateVars.GetTeslimatBilgiBySMSCode =
        result?.data.getTeslimatBilgiBySMSCode;
      formVars.teslimatyukle_884011_value = ReactSystemFunctions.toString(
        this,
        stateVars.GetTeslimatBilgiBySMSCode !== undefined
          ? stateVars.GetTeslimatBilgiBySMSCode?.length > 0
            ? stateVars.GetTeslimatBilgiBySMSCode[0].firmaAdi
            : null
          : this.state.GetTeslimatBilgiBySMSCode?.length > 0
          ? this.state.GetTeslimatBilgiBySMSCode[0].firmaAdi
          : null
      );
      formVars.teslimatyukle_488681_value = ReactSystemFunctions.toString(
        this,
        stateVars.GetTeslimatBilgiBySMSCode !== undefined
          ? stateVars.GetTeslimatBilgiBySMSCode?.length > 0
            ? stateVars.GetTeslimatBilgiBySMSCode[0].musteriAdi
            : null
          : this.state.GetTeslimatBilgiBySMSCode?.length > 0
          ? this.state.GetTeslimatBilgiBySMSCode[0].musteriAdi
          : null
      );
      formVars.teslimatyukle_992715_value = ReactSystemFunctions.toString(
        this,
        stateVars.GetTeslimatBilgiBySMSCode !== undefined
          ? stateVars.GetTeslimatBilgiBySMSCode?.length > 0
            ? stateVars.GetTeslimatBilgiBySMSCode[0].noktaAdi
            : null
          : this.state.GetTeslimatBilgiBySMSCode?.length > 0
          ? this.state.GetTeslimatBilgiBySMSCode[0].noktaAdi
          : null
      );
      stateVars.isComp280251Visible =
        ReactSystemFunctions.isEqualTo(
          ReactSystemFunctions.value(
            this,
            stateVars.GetTeslimatBilgiBySMSCode !== undefined
              ? stateVars.GetTeslimatBilgiBySMSCode?.length > 0
                ? stateVars.GetTeslimatBilgiBySMSCode[0].smsResent
                : null
              : this.state.GetTeslimatBilgiBySMSCode?.length > 0
              ? this.state.GetTeslimatBilgiBySMSCode[0].smsResent
              : null
          ),
          ReactSystemFunctions.convertToTypeByName("False", "string")
        ) === true
          ? "visible"
          : "hidden";
      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.TeslimatYuklePageInit2_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.TeslimatYuklePageInit2_();
          resolve();
        });
      });
    }

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  TeslimatYuklePageInit2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      YuklemeId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetTeslimatBilgiBySMSCode !== undefined
            ? stateVars.GetTeslimatBilgiBySMSCode?.length > 0
              ? stateVars.GetTeslimatBilgiBySMSCode[0].yuklemeId
              : null
            : this.state.GetTeslimatBilgiBySMSCode?.length > 0
            ? this.state.GetTeslimatBilgiBySMSCode[0].yuklemeId
            : null
        ),
        "Guid"
      ),
      TeslimatNo_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          stateVars.GetTeslimatBilgiBySMSCode !== undefined
            ? stateVars.GetTeslimatBilgiBySMSCode?.length > 0
              ? stateVars.GetTeslimatBilgiBySMSCode[0].teslimatNo
              : null
            : this.state.GetTeslimatBilgiBySMSCode?.length > 0
            ? this.state.GetTeslimatBilgiBySMSCode[0].teslimatNo
            : null
        ),
        "number"
      ),
    };

    if (
      ReactSystemFunctions.isGreaterThan(
        ReactSystemFunctions.value(
          this,
          stateVars.CheckSmsCodeIsUsed !== undefined
            ? stateVars.CheckSmsCodeIsUsed?.length > 0
              ? stateVars.CheckSmsCodeIsUsed[0].kontrol
              : null
            : this.state.CheckSmsCodeIsUsed?.length > 0
            ? this.state.CheckSmsCodeIsUsed[0].kontrol
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("0", "string")
      )
    ) {
      if (true) {
        KuikaAppManager.showSpinner(this);
      }
      let result = await KuikaAppManager.ApiRequest(
        this,
        "TeslimatYukle/TeslimatYuklePageInit2_",
        localVar
      );
      if (!KMainFunctions.IsResStatus2XX(result)) return true;

      stateVars.YuklemePlan_Get_TeslimEvrakListe =
        result?.data.yuklemePlan_Get_TeslimEvrakListe;

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.TeslimatYuklePageInit3_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.TeslimatYuklePageInit3_();
          resolve();
        });
      });
    }

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  TeslimatYuklePageInit3_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.CheckSmsCodeIsUsed !== undefined
            ? stateVars.CheckSmsCodeIsUsed?.length > 0
              ? stateVars.CheckSmsCodeIsUsed[0].kontrol
              : null
            : this.state.CheckSmsCodeIsUsed?.length > 0
            ? this.state.CheckSmsCodeIsUsed[0].kontrol
            : null
        ),
        "0"
      )
    ) {
      stateVars.Notify = await ReactSystemFunctions.notify(
        this,
        ReactSystemFunctions.translateCustomActions(
          this.ml,
          "11c7df5f_43e3_8881_ad9c_f56f8524f44c_notify",
          this.defaultML,
          "BU SMS KODU DAHA ÖNCE KULLANILMIŞ"
        ),
        ReactSystemFunctions.convertToTypeByName("danger", "string"),
        ReactSystemFunctions.convertToTypeByName("center", "string"),
        0,
        ReactSystemFunctions.convertToTypeByName("", "string"),
        ReactSystemFunctions.convertToTypeByName("", "string"),
        0
      );

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.TeslimatYuklePageInit4_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.TeslimatYuklePageInit4_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  TeslimatYuklePageInit4_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isGreaterThan(
        ReactSystemFunctions.value(
          this,
          stateVars.CheckSmsCodeIsUsed !== undefined
            ? stateVars.CheckSmsCodeIsUsed?.length > 0
              ? stateVars.CheckSmsCodeIsUsed[0].kontrol
              : null
            : this.state.CheckSmsCodeIsUsed?.length > 0
            ? this.state.CheckSmsCodeIsUsed[0].kontrol
            : null
        ),
        "0"
      )
    ) {
      formVars.teslimatyukle_884011_value = ReactSystemFunctions.toString(
        this,
        stateVars.GetTeslimatBilgiBySMSCode !== undefined
          ? stateVars.GetTeslimatBilgiBySMSCode?.length > 0
            ? stateVars.GetTeslimatBilgiBySMSCode[0].firmaAdi
            : null
          : this.state.GetTeslimatBilgiBySMSCode?.length > 0
          ? this.state.GetTeslimatBilgiBySMSCode[0].firmaAdi
          : null
      );

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.TeslimatYuklePageInit5_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.TeslimatYuklePageInit5_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  TeslimatYuklePageInit5_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isGreaterThan(
        ReactSystemFunctions.value(
          this,
          stateVars.CheckSmsCodeIsUsed !== undefined
            ? stateVars.CheckSmsCodeIsUsed?.length > 0
              ? stateVars.CheckSmsCodeIsUsed[0].kontrol
              : null
            : this.state.CheckSmsCodeIsUsed?.length > 0
            ? this.state.CheckSmsCodeIsUsed[0].kontrol
            : null
        ),
        "0"
      )
    ) {
      formVars.teslimatyukle_488681_value = ReactSystemFunctions.toString(
        this,
        stateVars.GetTeslimatBilgiBySMSCode !== undefined
          ? stateVars.GetTeslimatBilgiBySMSCode?.length > 0
            ? stateVars.GetTeslimatBilgiBySMSCode[0].musteriAdi
            : null
          : this.state.GetTeslimatBilgiBySMSCode?.length > 0
          ? this.state.GetTeslimatBilgiBySMSCode[0].musteriAdi
          : null
      );

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.TeslimatYuklePageInit6_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.TeslimatYuklePageInit6_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  TeslimatYuklePageInit6_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isGreaterThan(
        ReactSystemFunctions.value(
          this,
          stateVars.CheckSmsCodeIsUsed !== undefined
            ? stateVars.CheckSmsCodeIsUsed?.length > 0
              ? stateVars.CheckSmsCodeIsUsed[0].kontrol
              : null
            : this.state.CheckSmsCodeIsUsed?.length > 0
            ? this.state.CheckSmsCodeIsUsed[0].kontrol
            : null
        ),
        "0"
      )
    ) {
      formVars.teslimatyukle_992715_value = ReactSystemFunctions.toString(
        this,
        stateVars.GetTeslimatBilgiBySMSCode !== undefined
          ? stateVars.GetTeslimatBilgiBySMSCode?.length > 0
            ? stateVars.GetTeslimatBilgiBySMSCode[0].noktaAdi
            : null
          : this.state.GetTeslimatBilgiBySMSCode?.length > 0
          ? this.state.GetTeslimatBilgiBySMSCode[0].noktaAdi
          : null
      );

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.TeslimatYuklePageInit7_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.TeslimatYuklePageInit7_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  TeslimatYuklePageInit7_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isGreaterThan(
        ReactSystemFunctions.value(
          this,
          stateVars.CheckSmsCodeIsUsed !== undefined
            ? stateVars.CheckSmsCodeIsUsed?.length > 0
              ? stateVars.CheckSmsCodeIsUsed[0].kontrol
              : null
            : this.state.CheckSmsCodeIsUsed?.length > 0
            ? this.state.CheckSmsCodeIsUsed[0].kontrol
            : null
        ),
        "0"
      )
    ) {
      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.TeslimatYuklePageInit8_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.TeslimatYuklePageInit8_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  TeslimatYuklePageInit8_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isGreaterThan(
        ReactSystemFunctions.value(
          this,
          stateVars.CheckSmsCodeIsUsed !== undefined
            ? stateVars.CheckSmsCodeIsUsed?.length > 0
              ? stateVars.CheckSmsCodeIsUsed[0].kontrol
              : null
            : this.state.CheckSmsCodeIsUsed?.length > 0
            ? this.state.CheckSmsCodeIsUsed[0].kontrol
            : null
        ),
        "0"
      )
    ) {
      stateVars.dataSource_185972 =
        stateVars.YuklemePlan_Get_TeslimEvrakListe ??
        this.state.YuklemePlan_Get_TeslimEvrakListe;

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.TeslimatYuklePageInit9_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.TeslimatYuklePageInit9_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  TeslimatYuklePageInit9_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.isComp622971Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "teslimatyukle_966026_value",
            "value",
            "",
            "",
            ""
          )
        ),
        true
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp449349Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "teslimatyukle_156919_value",
            "value",
            "",
            "",
            ""
          )
        ),
        true
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp280251Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetTeslimatBilgiBySMSCode !== undefined
            ? stateVars.GetTeslimatBilgiBySMSCode?.length > 0
              ? stateVars.GetTeslimatBilgiBySMSCode[0].smsResent
              : null
            : this.state.GetTeslimatBilgiBySMSCode?.length > 0
            ? this.state.GetTeslimatBilgiBySMSCode[0].smsResent
            : null
        ),
        false
      ) === true
        ? "visible"
        : "hidden";

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  TeslimatYukleComponent_947103_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.PhotosFromGallery = (
      (await ReactSystemFunctions.getPhotosFromGallery(
        false,
        ReactSystemFunctions.convertToTypeByName("high", "string")
      )) as any
    ).data;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.TeslimatYukleComponent_947103_onClick1_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  TeslimatYukleComponent_947103_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      YuklemeId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetTeslimatBilgiBySMSCode !== undefined
            ? stateVars.GetTeslimatBilgiBySMSCode?.length > 0
              ? stateVars.GetTeslimatBilgiBySMSCode[0].yuklemeId
              : null
            : this.state.GetTeslimatBilgiBySMSCode?.length > 0
            ? this.state.GetTeslimatBilgiBySMSCode[0].yuklemeId
            : null
        ),
        "Guid"
      ),
      TeslimatNo_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          stateVars.GetTeslimatBilgiBySMSCode !== undefined
            ? stateVars.GetTeslimatBilgiBySMSCode?.length > 0
              ? stateVars.GetTeslimatBilgiBySMSCode[0].teslimatNo
              : null
            : this.state.GetTeslimatBilgiBySMSCode?.length > 0
            ? this.state.GetTeslimatBilgiBySMSCode[0].teslimatNo
            : null
        ),
        "number"
      ),
      DocumentData_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.PhotosFromGallery !== undefined
            ? stateVars.PhotosFromGallery?.length > 0
              ? stateVars.PhotosFromGallery[0].dataBase64
              : null
            : this.state.PhotosFromGallery?.length > 0
            ? this.state.PhotosFromGallery[0].dataBase64
            : null
        ),
        "string"
      ),
      DocumentName_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.PhotosFromGallery !== undefined
            ? stateVars.PhotosFromGallery?.length > 0
              ? stateVars.PhotosFromGallery[0].name
              : null
            : this.state.PhotosFromGallery?.length > 0
            ? this.state.PhotosFromGallery[0].name
            : null
        ),
        "string"
      ),
      YuklemeTipi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("TESLIMAT EKRAN", "string"),
        "string"
      ),
      SmsResent_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetTeslimatBilgiBySMSCode !== undefined
            ? stateVars.GetTeslimatBilgiBySMSCode?.length > 0
              ? stateVars.GetTeslimatBilgiBySMSCode[0].smsResent
              : null
            : this.state.GetTeslimatBilgiBySMSCode?.length > 0
            ? this.state.GetTeslimatBilgiBySMSCode[0].smsResent
            : null
        ),
        "boolean"
      ),
      YuklemeId_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetTeslimatBilgiBySMSCode !== undefined
            ? stateVars.GetTeslimatBilgiBySMSCode?.length > 0
              ? stateVars.GetTeslimatBilgiBySMSCode[0].yuklemeId
              : null
            : this.state.GetTeslimatBilgiBySMSCode?.length > 0
            ? this.state.GetTeslimatBilgiBySMSCode[0].yuklemeId
            : null
        ),
        "Guid"
      ),
      TeslimatNo_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          stateVars.GetTeslimatBilgiBySMSCode !== undefined
            ? stateVars.GetTeslimatBilgiBySMSCode?.length > 0
              ? stateVars.GetTeslimatBilgiBySMSCode[0].teslimatNo
              : null
            : this.state.GetTeslimatBilgiBySMSCode?.length > 0
            ? this.state.GetTeslimatBilgiBySMSCode[0].teslimatNo
            : null
        ),
        "number"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "TeslimatYukle/TeslimatYukleComponent_947103_onClick1_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.YuklemePlan_Save_TeslimEvrak =
      result?.data.yuklemePlan_Save_TeslimEvrak;
    stateVars.YuklemePlan_Get_TeslimEvrakListe =
      result?.data.yuklemePlan_Get_TeslimEvrakListe;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.TeslimatYukleComponent_947103_onClick2_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  TeslimatYukleComponent_947103_onClick2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          stateVars.YuklemePlan_Save_TeslimEvrak !== undefined
            ? stateVars.YuklemePlan_Save_TeslimEvrak?.length > 0
              ? stateVars.YuklemePlan_Save_TeslimEvrak[0].sonuc
              : null
            : this.state.YuklemePlan_Save_TeslimEvrak?.length > 0
            ? this.state.YuklemePlan_Save_TeslimEvrak[0].sonuc
            : null
        ),
        "OK"
      )
    ) {
      stateVars.Notify = await ReactSystemFunctions.notify(
        this,
        ReactSystemFunctions.translateCustomActions(
          this.ml,
          "809c62ec_33cd_b120_1739_3a7085cb1f83_notify",
          this.defaultML,
          "EVRAK YÜKLENDİ."
        ),
        ReactSystemFunctions.convertToTypeByName("success", "string"),
        ReactSystemFunctions.convertToTypeByName("center", "string"),
        5,
        ReactSystemFunctions.convertToTypeByName("", "string"),
        ReactSystemFunctions.convertToTypeByName("", "string"),
        0
      );

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.TeslimatYukleComponent_947103_onClick3_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.TeslimatYukleComponent_947103_onClick3_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  TeslimatYukleComponent_947103_onClick3_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(
          this,
          stateVars.YuklemePlan_Save_TeslimEvrak !== undefined
            ? stateVars.YuklemePlan_Save_TeslimEvrak?.length > 0
              ? stateVars.YuklemePlan_Save_TeslimEvrak[0].sonuc
              : null
            : this.state.YuklemePlan_Save_TeslimEvrak?.length > 0
            ? this.state.YuklemePlan_Save_TeslimEvrak[0].sonuc
            : null
        ),
        "OK"
      )
    ) {
      stateVars.Notify = await ReactSystemFunctions.notify(
        this,
        ReactSystemFunctions.toString(
          this,
          stateVars.YuklemePlan_Save_TeslimEvrak !== undefined
            ? stateVars.YuklemePlan_Save_TeslimEvrak?.length > 0
              ? stateVars.YuklemePlan_Save_TeslimEvrak[0].sonuc
              : null
            : this.state.YuklemePlan_Save_TeslimEvrak?.length > 0
            ? this.state.YuklemePlan_Save_TeslimEvrak[0].sonuc
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("danger", "string"),
        ReactSystemFunctions.convertToTypeByName("center", "string"),
        5,
        ReactSystemFunctions.convertToTypeByName("", "string"),
        ReactSystemFunctions.convertToTypeByName("", "string"),
        0
      );

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.TeslimatYukleComponent_947103_onClick4_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.TeslimatYukleComponent_947103_onClick4_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  TeslimatYukleComponent_947103_onClick4_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_185972 =
      stateVars.YuklemePlan_Get_TeslimEvrakListe ??
      this.state.YuklemePlan_Get_TeslimEvrakListe;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  TeslimatYukleComponent_280251_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      SMSCode_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.SMSCode ?? this.props.screenInputs.smscode,
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "TeslimatYukle/TeslimatYukleComponent_280251_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetTeslimatBilgiBySMSCode =
      result?.data.getTeslimatBilgiBySMSCode;
    formVars.teslimatyukle_884011_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetTeslimatBilgiBySMSCode !== undefined
        ? stateVars.GetTeslimatBilgiBySMSCode?.length > 0
          ? stateVars.GetTeslimatBilgiBySMSCode[0].firmaAdi
          : null
        : this.state.GetTeslimatBilgiBySMSCode?.length > 0
        ? this.state.GetTeslimatBilgiBySMSCode[0].firmaAdi
        : null
    );
    formVars.teslimatyukle_488681_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetTeslimatBilgiBySMSCode !== undefined
        ? stateVars.GetTeslimatBilgiBySMSCode?.length > 0
          ? stateVars.GetTeslimatBilgiBySMSCode[0].musteriAdi
          : null
        : this.state.GetTeslimatBilgiBySMSCode?.length > 0
        ? this.state.GetTeslimatBilgiBySMSCode[0].musteriAdi
        : null
    );
    formVars.teslimatyukle_992715_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetTeslimatBilgiBySMSCode !== undefined
        ? stateVars.GetTeslimatBilgiBySMSCode?.length > 0
          ? stateVars.GetTeslimatBilgiBySMSCode[0].noktaAdi
          : null
        : this.state.GetTeslimatBilgiBySMSCode?.length > 0
        ? this.state.GetTeslimatBilgiBySMSCode[0].noktaAdi
        : null
    );
    stateVars.isComp280251Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetTeslimatBilgiBySMSCode !== undefined
            ? stateVars.GetTeslimatBilgiBySMSCode?.length > 0
              ? stateVars.GetTeslimatBilgiBySMSCode[0].smsResent
              : null
            : this.state.GetTeslimatBilgiBySMSCode?.length > 0
            ? this.state.GetTeslimatBilgiBySMSCode[0].smsResent
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("False", "string")
      ) === true
        ? "visible"
        : "hidden";
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.TeslimatYukleComponent_280251_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  TeslimatYukleComponent_280251_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      Aciklama_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "teslimatyukle_242782_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      EksikFazla_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "teslimatyukle_156919_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "boolean"
      ),
      EksikFazlaMiktar_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "teslimatyukle_449349_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      HasarIade_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "teslimatyukle_966026_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "boolean"
      ),
      HasarliMiktar_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "teslimatyukle_622971_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      IadeVar_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "teslimatyukle_752493_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "boolean"
      ),
      YuklemeId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetTeslimatBilgiBySMSCode !== undefined
            ? stateVars.GetTeslimatBilgiBySMSCode?.length > 0
              ? stateVars.GetTeslimatBilgiBySMSCode[0].yuklemeId
              : null
            : this.state.GetTeslimatBilgiBySMSCode?.length > 0
            ? this.state.GetTeslimatBilgiBySMSCode[0].yuklemeId
            : null
        ),
        "Guid"
      ),
      TeslimatNo_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          stateVars.GetTeslimatBilgiBySMSCode !== undefined
            ? stateVars.GetTeslimatBilgiBySMSCode?.length > 0
              ? stateVars.GetTeslimatBilgiBySMSCode[0].teslimatNo
              : null
            : this.state.GetTeslimatBilgiBySMSCode?.length > 0
            ? this.state.GetTeslimatBilgiBySMSCode[0].teslimatNo
            : null
        ),
        "number"
      ),
    };

    stateVars.Confirm = await ReactSystemFunctions.confirmation(
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "6b269cfa_aea4_12a9_f172_f57b42ba8c87_confirmation",
        this.defaultML,
        "TESLIMAT KAPATILACAK. EMIN MISINIZ ?"
      ),
      "poppins",
      "",
      "",
      "#246dff"
    );

    if (stateVars.Confirm) {
      if (true) {
        KuikaAppManager.showSpinner(this);
      }
      let result = await KuikaAppManager.ApiRequest(
        this,
        "TeslimatYukle/TeslimatYukleComponent_280251_onClick1_",
        localVar
      );
      if (!KMainFunctions.IsResStatus2XX(result)) return true;

      stateVars.YuklemePlan_TeslimatKaydet =
        result?.data.yuklemePlan_TeslimatKaydet;
      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.TeslimatYukleComponent_280251_onClick2_();
          resolve();
        });
      });
    }

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  TeslimatYukleComponent_280251_onClick2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "afe5b480_8b8f_a975_9023_14627c267608_notify",
        this.defaultML,
        "YUKLEME TAMAMLANDI. BİR SONRAKİ SEVKİYATA DEVAM EDİN"
      ),
      ReactSystemFunctions.convertToTypeByName("success", "string"),
      ReactSystemFunctions.convertToTypeByName("center", "string"),
      0,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );
    formVars.teslimatyukle_884011_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetTeslimatBilgiBySMSCode !== undefined
        ? stateVars.GetTeslimatBilgiBySMSCode?.length > 0
          ? stateVars.GetTeslimatBilgiBySMSCode[0].firmaAdi
          : null
        : this.state.GetTeslimatBilgiBySMSCode?.length > 0
        ? this.state.GetTeslimatBilgiBySMSCode[0].firmaAdi
        : null
    );

    formVars.teslimatyukle_488681_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetTeslimatBilgiBySMSCode !== undefined
        ? stateVars.GetTeslimatBilgiBySMSCode?.length > 0
          ? stateVars.GetTeslimatBilgiBySMSCode[0].musteriAdi
          : null
        : this.state.GetTeslimatBilgiBySMSCode?.length > 0
        ? this.state.GetTeslimatBilgiBySMSCode[0].musteriAdi
        : null
    );

    formVars.teslimatyukle_992715_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetTeslimatBilgiBySMSCode !== undefined
        ? stateVars.GetTeslimatBilgiBySMSCode?.length > 0
          ? stateVars.GetTeslimatBilgiBySMSCode[0].noktaAdi
          : null
        : this.state.GetTeslimatBilgiBySMSCode?.length > 0
        ? this.state.GetTeslimatBilgiBySMSCode[0].noktaAdi
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  TeslimatYukleComponent_966026_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.isComp622971Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "teslimatyukle_966026_value",
            "value",
            "",
            "",
            ""
          )
        ),
        true
      ) === true
        ? "visible"
        : "hidden";

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  TeslimatYukleComponent_156919_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.isComp449349Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "teslimatyukle_156919_value",
            "value",
            "",
            "",
            ""
          )
        ),
        true
      ) === true
        ? "visible"
        : "hidden";

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [] as number[];
    if (isFromMaster || pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.TeslimatYuklePageInit();
    }
  }
}
